import { createAction, createPayloadAction } from '../../../core/helpers'

import { FETCH_DISH_TYPE, SET_DISH_TYPE_PAGE_TO_DIRTY } from '../action-types'

export const cleanupFetchDishType = createAction(FETCH_DISH_TYPE.CLEANUP)

export const setDishTypePageIsDirty = createPayloadAction(
  SET_DISH_TYPE_PAGE_TO_DIRTY,
)
